import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import InfiniteScroll from "react-infinite-scroll-component";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import {
  AddProjectLightIcon,
  FilterIcon,
  NoDataImage,
  SearchFilterIconMob,
  SearchIcon,
  SearchIconMobile,
} from "../../assets/icons/icons";
import DefaultImage from "../../assets/img/simulanis.png";
import apiclient from "../../apiclient/index";
import { PROJECT_CLONE, PROJECT_DELETE, PROJECT_LIST } from "../../apiclient/apiEndpoints";
import { PROJECT_LIMIT } from "../../utils/constant";
import ProjectSkeleton from "../../components/skeleton/project";
import AddProject from "../../components/modals/AddProject";
import ShareModal from "../../components/modals/ShareModal";
import ShareEditModal from "../../components/modals/ShareEditModal";
import HeaderMobile from "../../components/layout/HeaderMobile";
import useDebounce from "../../hooks/useDebounce";
import { CLONE, DELETE, SHARE, SHARE_EDIT } from "../../constant/constant";
import IntroModal from "../../components/modals/IntroModal";

const { useUnoSelector } = UnoStoreHooks;
const { FilterTab, SearchBar, NormalGradientButton, ConfirmBox, SimModal } = UiComponents;

const defaultAction = {
  [SHARE]: false,
  [SHARE_EDIT]: false,
  [DELETE]: false,
  [CLONE]: false,
  loading: false,
  details: null,
};

const Project = ({ isMobileView }) => {
  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [paginationPage, setPaginationPage] = useState(1);
  const [filterOption, setFilterOption] = useState([
    {
      name: "Status",
      tags: [
        { name: "Published", key: "published", value: true },
        { name: "Ongoing", key: "ongoing", value: false },
        { name: "My Project", key: "OWNER", value: "OWNER" },
      ],
    },
  ]);
  const [addProject, setAddProject] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [actionModal, setActionModal] = useState({ ...defaultAction });

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [copyLinkFlag, setCopyLinkFlag] = useState(false);

  const handleToggle = (projectId) => {
    setOpenDropdownId((prev) => (prev === projectId ? null : projectId));
  };

  const getProjectList = async (pageId = null, searchValue = null, selectedCheckbox = []) => {
    let pageNumber = pageId || paginationPage;
    try {
      setHasMore(true);
      let data = await apiclient.get(`${configData.config.API_URL}${PROJECT_LIST}`, {
        params: {
          limit: PROJECT_LIMIT,
          page: pageNumber,
          search: searchValue,
          selectedCheckbox: selectedCheckbox.map((e) => e.key),
        },
      });
      setList((pre) => (pageNumber == 1 ? [...data] : [...pre, ...data]));
      setHasMore(data.length === PROJECT_LIMIT);
      setPaginationPage(data.length === PROJECT_LIMIT ? Number(pageNumber) + 1 : 1);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetProjectList = () => {
    setLoading(true);
    getProjectList(1, search, selectedCheckbox);
  };

  let debounceSearch = useDebounce(search, 500);

  useEffect(() => {
    handleGetProjectList();
  }, [debounceSearch, selectedCheckbox]);

  const handleCardClick = (project) => {
    if (project.role == "VIEWER" || (configData?.config?.permissions?.createProject === false)) {
      return navigate(`/view/${project.uuid}`, { state: { openIntroModal: true, title: project.name } });
    }
    navigate(`/editor/${project.uuid}`);
  };

  const loadMoreData = () => {
    getProjectList(paginationPage, search, selectedCheckbox);
  };

  const handleOpenAction = (type, details) => {
    setActionModal({
      ...defaultAction,
      [type]: true,
      details,
    });
  };

  const handleCopyLink = (project) => {
    setCopyLinkFlag(true);
    navigator.clipboard.writeText(`${window.location.origin}/view/${project?.uuid}`);
    setTimeout(() => setCopyLinkFlag(false), 1000);
  };
  const handleCloseAction = () => {
    setActionModal({ ...defaultAction });
  };

  const handleDeleteProject = async () => {
    let _projectId = actionModal?.details?.uuid || null;
    if (actionModal.loading || !_projectId) return;
    setActionModal((pre) => ({ ...pre, loading: true }));
    try {
      let bodyData = {
        list: [_projectId],
      };
      await apiclient.post(`${configData.config.API_URL}${PROJECT_DELETE}`, bodyData);
      handleGetProjectList();
    } catch (error) {
      console.log(error);
    } finally {
      setActionModal(defaultAction);
    }
  };

  const handleCloneProject = async () => {
    let _projectId = actionModal?.details?.uuid;
    if (actionModal.loading && !_projectId) return;
    setActionModal((pre) => ({ ...pre, loading: true }));
    try {
      await apiclient.get(`${configData.config.API_URL}${PROJECT_CLONE}/${_projectId}`);
      handleGetProjectList();
    } catch (error) {
      console.log(error);
    } finally {
      setActionModal(defaultAction);
    }
  };

  const openFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const resetCheckBox = () => {
    setSelectedCheckbox([]);
  };

  const handleSelectItem = (item) => {
    setSelectedCheckbox((pre) => {
      const exists = pre.find((selectedItem) => selectedItem.key === item.key);
      const updatedArray = exists ? pre.filter((selectedItem) => selectedItem.key !== item.key) : [...pre, item];
      return updatedArray;
    });
  };

  const handleCloseIntroModal = () => {
    setShowIntroModal(false);
  }

  return (
    <>

      {isMobileView && <HeaderMobile />}
      <div className="projectPage">
        {!isMobileView ? (
          <div className="page-title">
            <div className="col-md-6">
              <h6>Project List</h6>
            </div>
            <div className="search-parent">
              <SearchBar placeholder="Search ..." value={search} onChange={(e) => setSearch(e.target.value)} />

              {(configData?.config?.permissions?.createProject ?? true) &&
                <NormalGradientButton
                  icon={<AddProjectLightIcon />}
                  text="Add Project"
                  onClick={() => setAddProject(true)}
                />}

              <div className="filterbtn" onClick={openFilter}>
                <div className="btninadjust">
                  <FilterIcon />
                  {selectedCheckbox.length > 0 && <span className="filter-active-span">{""}</span>}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="mobSearchFunctions">
            <div className="searchMobile noFilter">
              <input type="text" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
              <span className="searchIcon">
                <SearchIconMobile />
              </span>

              <span className="filterIcon" onClick={openFilter}>
                <SearchFilterIconMob />
                {selectedCheckbox.length > 0 && <span className="filter-active-span">{""}</span>}
              </span>
            </div>
          </div>
        )}

        <div className="project-list-container">
          {loading ? (
            <div className="card-list">
              <ProjectSkeleton count={5} />{" "}
            </div>
          ) : list.length === 0 && search.length === 0 ? (
            <>
              <div className="empty-state">
                <NoDataImage />
                <p>You haven’t created or joined any projects yet.</p>
                {(!isMobileView && (configData?.config?.permissions?.createProject ?? true)) && (
                  <p>
                    Click <strong>"Add Project"</strong> above to get started.
                  </p>
                )}
              </div>
            </>
          ) : list.length === 0 && search.length > 0 ? (
            <>
              <div className="empty-state">
                <NoDataImage />
                <p>
                  No projects found for <strong>"{search}"</strong>.
                </p>
                {!isMobileView && (
                  <p>
                    Try a different search term or click <strong>"Add Project"</strong> to create a new one.
                  </p>
                )}
              </div>
            </>
          ) : (
            <>
              <div id="scrollableDivGroups" className="scrollable-container">
                <InfiniteScroll
                  scrollThreshold={0.7}
                  dataLength={list.length}
                  next={() => loadMoreData()}
                  hasMore={hasMore}
                  // loader={<div className="card-list"> </div>}
                  scrollableTarget="scrollableDivGroups"
                >
                  <div className="card-list ">
                    {list.map((project) => (
                      <div
                        className="card-item"
                        key={project.uuid}
                        onClick={() => handleCardClick(project)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className={project?.thumbnail ? "card-thumb " : "card-thumb not-thumb"}>
                          <img
                            src={project?.thumbnail || DefaultImage}
                            alt={project.name}
                            referrerPolicy="no-referrer"
                          />
                        </div>

                        <div className="card-info">
                          <div className="card-info-item">
                            <h6 title={project.name}>{project.name}</h6>
                            {((userData.user.uuid === project?.owner?.uuid || project?.role != "VIEWER") && (configData?.config?.permissions?.createProject ?? true)) && (
                              <div className="dropdown-wrapper" onClick={(e) => e.stopPropagation()}>
                                <div className="userdrop">
                                  <Dropdown
                                    show={openDropdownId === project.uuid}
                                    onToggle={() => handleToggle(project.uuid)}
                                  >
                                    <Dropdown.Toggle id="dropdown-basic ">
                                      <div className="options">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-three-dots-vertical"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                        </svg>
                                      </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="sidebartopbar modulelistoptions">
                                      <div className="listoptionsmodule">
                                        {userData.user.uuid === project?.owner?.uuid && (
                                          <span onClick={() => handleOpenAction(DELETE, project)}>Delete Project</span>
                                        )}
                                        {project?.role != "VIEWER" && (
                                          <>
                                            <span onClick={() => handleOpenAction(SHARE, project)}>Share Project</span>
                                            <span onClick={() => handleOpenAction(CLONE, project)}>Clone</span>
                                            <span onClick={() => handleCopyLink(project)}>
                                              {copyLinkFlag ? "Copied" : "Copy Link"}
                                            </span>
                                          </>
                                        )}
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            )}
                          </div>

                          {project.owner && (
                            <div class="owner-detail">
                              {project?.owner?.avatar ? (
                                <img
                                  src={project?.owner?.avatar || ""}
                                  referrerPolicy="no-referrer"
                                  alt="User Profile"
                                />
                              ) : (
                                <span className="initials">
                                  {project?.owner?.name
                                    ?.split(" ")
                                    ?.slice(0, 2)
                                    ?.map((word) => word[0])
                                    ?.join("")
                                    ?.toUpperCase()}
                                </span>
                              )}
                              <p class="user-name"> {project?.owner?.name} </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}

                    {hasMore && <ProjectSkeleton count={4} />}
                  </div>
                </InfiniteScroll>
              </div>
            </>
          )}
        </div>
      </div>

      <AddProject
        show={addProject}
        handleClose={() => setAddProject(false)}
        handleGetProjectList={handleGetProjectList}
      />

      <SimModal showModal={actionModal[SHARE]} onHide={handleCloseAction} centered size="md">
        <ShareModal
          details={actionModal?.details}
          onHide={handleCloseAction}
          onOpenEditModal={() => handleOpenAction(SHARE_EDIT, actionModal?.details)}
        />
      </SimModal>

      <SimModal showModal={actionModal[SHARE_EDIT]} onHide={handleCloseAction} centered size="md">
        <ShareEditModal
          onHide={handleCloseAction}
          details={actionModal?.details}
          handleOpenShareModal={() => handleOpenAction(SHARE, actionModal?.details)}
        />
      </SimModal>

      <ConfirmBox
        showModal={actionModal[DELETE] || actionModal[CLONE]}
        onHide={handleCloseAction}
        alertTitle={actionModal[DELETE] ? "Delete Project" : "Make a clone"}
        alertMessage={
          actionModal[DELETE]
            ? "This project will be deleted and can not be recovered. Are you sure you want to continue?"
            : "Do you really want to clone this project?"
        }
        onActionClick={actionModal[DELETE] ? handleDeleteProject : handleCloneProject}
        clickLoading={actionModal.loading}
        actionButtonItem={actionModal[DELETE] ? "Delete" : "Yes"}
      />

      <FilterTab
        showfilter={showFilter}
        selectedCheckboxes={selectedCheckbox}
        filterOptions={filterOption}
        onToggleFilter={openFilter}
        setSelectedCheckboxes={(e) => handleSelectItem(e)}
        handleResetCheckBox={resetCheckBox}
      />

      <IntroModal show={showIntroModal} handleClose={handleCloseIntroModal} />

    </>
  );
};

export default Project;
